import moment from "moment";
const paramDateFormat = "YYYY-MM-DD";

export default {
  methods: {
    handlePaymentsData(payments) {
      let returnData = [];

      returnData = Object.entries(payments).map(payment => {
        const dateRange = this.getDateRange(payment[0]);
        return {
          start: dateRange.start,
          end: dateRange.end,
          label: payment[0],
          payment: payment[1]
        };
      });

      return returnData;
    },


    /**
     * Get the start and end date of a month from the the Month Name and Year
     * 
     * @param {*} monthNameYear
     */
    getDateRange(monthNameYear) {
      const monthNameYearArray = monthNameYear.split(" ");
      const monthNumber = this.getMonthNumber(monthNameYearArray[0]) + 1;
      const year = monthNameYearArray[1];
      const dateId = year + "-" + monthNumber + "-01";
      const formattedStartDateId = moment(dateId, paramDateFormat).format(paramDateFormat);
      const month = moment(formattedStartDateId, paramDateFormat);

      return {
        start: month.startOf("month").format(paramDateFormat),
        end: month.endOf("month").format(paramDateFormat)
      };
    },

    getMonthNumber: function (monthName) {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      return months.indexOf(monthName);
    }
  }
}